import FieldDefs from './AdsFieldDefs.js';
import {doLangFields} from '../../../lib/ks-tools';
import AdsSelector from "./mixins/Selector";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    mixins: [AdsSelector],
    data() {
        return {
            fields: doLangFields(this, "lang.group_report.ads", FieldDefs),
            sortOrder: [
                {
                    field: 'keyscnt',
                    direction: 'desc'
                }
            ],
            viewMode: '',
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
